module.exports = __webpack_public_path__ + "img/confused.be0ecc5f.svg";